// 个人中心新站点
export const NewMySites = ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'kr', 'za', 'au', 'br', 'mx', 'ph', 'sa', 'nl'];
